import Vue from 'vue'
import router from './router'
import store from './store'
import { isWebview,getSearchParams } from '@/utils/util.js'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { axios } from './utils/request'
import   {getAliyunAuditStatistics} from '@/api/common.js'

const listenAudioCount = async () => {
  window.__intervalTime__ = 60 * 15
  const bussdepId = store.state.user.info.bussdepId
  const sleep = time => new Promise(resolve => setTimeout(resolve, time * 1000))
  const getAudioCount = async () => {
    const now = Math.floor(Date.now() / 1000)
    const intervalTime = window.__intervalTime__
    const waitTime = Math.floor(intervalTime / 15)
    const inTime = now % intervalTime < waitTime
    if (inTime) {
      const { code, result } = await getAliyunAuditStatistics({ bussdepId })
      if (result) {
        notification.info({
          message: '阿里云自动审核通知',
          description: `近15分钟阿里云自动拒绝${result || 0}条内容，拒绝内容可在复审页面查看`,
          duration: 60,
          placement: 'bottomRight'
        })
      }
      await sleep(waitTime * 2)
    } else {
      await sleep(1)
    }
    await getAudioCount()
  }
  getAudioCount()
}

NProgress.configure({ showSpinner: false }) // NProgress Configuration
// iframe 插入登陆状态
if(isWebview()){
  Vue.ls.set(ACCESS_TOKEN, getSearchParams().token, 7 * 24 * 60 * 60 * 1000)
  store.commit('SET_TOKEN', getSearchParams().token)
}
const whiteList = ['login', 'register', 'registerResult', 'repassword', 'logout'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ name: 'index' })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        store
          .dispatch('GetInfo')
          .then(res => {
            listenAudioCount()
            const roles = res.result && res.result.role
            // 调用 vuex 的 从后端获取用户的路由菜单，动态添加可访问路由表
            store.dispatch('GenerateRoutes', { roles }).then(() => {
              // 把已获取到的路由菜单加入到路由表中
              router.addRoutes(store.getters.addRouters)
              // const redirect = decodeURIComponent(from.query.redirect || to.path)
              // if (to.path === redirect) {
              // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
              next({ ...to, replace: true })
              // } else {
              //   // 跳转到目的路由,如果切换账号，会跳404
              //   next({ path: redirect })
              // }
            })
          })
          .catch(() => {
            notification.error({
              message: '错误',
              description: '请求用户信息失败，请重试'
            })
            store.dispatch('Logout').then(() => {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  bind: function(el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles
    const elVal = vnode.context.$route.meta.permission
    const permissionId = (elVal instanceof String && [elVal]) || elVal
    roles.permissions.forEach(p => {
      if (!permissionId.includes(p.permissionId)) {
        return
      }
      if (p.actionList && !p.actionList.includes(actionName)) {
        ;(el.parentNode && el.parentNode.removeChild(el)) || (el.style.display = 'none')
      }
    })
  }
})

export { action }
